<template>
	<b-container class="show-document" style="width:1000px">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back')
					}}
				</b-button>
			</div>
			<div class="pull-right">
				<!-- <b-button
					variant="outline-dark"
					@click="editAvizModal"
					class="mr-2"
				>
					<i class="fa fa-edit"></i>
					{{$t('kochirish.edit')}}
				</b-button> -->
				<b-button
					variant="outline-primary"
					@click="excelExport('whDocTable', item.regNumber)"
					class="mr-2"
				>
					{{ $t('excel-export.download-excel') }}
				</b-button>
				<b-button
					variant="outline-dark"
					@click="print"
					class="mr-2"
				>
					<i class="fa fa-print"></i>
					{{$t('pricing.print')}}
				</b-button>

			</div>
			<div class="clearfix"></div>

		</div>
		<div class="doc-body">
			<b-card class="p-3" style="min-height:29.7cm; min-width:21cm !important;" >
				<div class="generalTableClass documentItems mt-2">
					<div style="border:2px solid black;min-height:29.7cm">
						<table class="table table-bordered" style="border:0px solid black" id="whDocTable">

                            <tr class="thead-first" >
                                <th colspan="2" class="pl-2 pt-2 text-left" >
                                    <ul style="list-style:none">
										<!-- <pre>
											{{item}}
										</pre> -->
                                        <li>Furnizor: {{item.fromDepartmentName}}</li>
                                        <li>Reg. com.: J22/155/2018</li>
                                        <li>CIF:RO38743835</li>
                                        <li>Adresa: {{item.fromAddress}}</li>
                                        <li>IBAN: {{item.fromBankAccount}}</li>
                                        <li>Banca: BRD - GROUPE SOCIET</li>
                                        <li>GENERALE</li>
                                        <li>Capital social: 0</li>
                                    </ul>
                                </th>
                                <th  colspan="3"
                                 class="text-center">
                                    <ul style="list-style:none" class="mb-5">
                                        <li style="font-size: 26px">AVIZ DE INSOTIRE A MARFII</li>
                                        <ul style="list-style: none; ">
                                        <div style="border:1px solid black" class="p-2">
                                             <li>Seria AVG nr. {{aviz.initialLetter}}{{regNumber}} </li>
                                            <li>Data (zi/luna/an): 06/12/2019</li>
                                            <li>Cota TVA: {{vatPercentage}}%</li>
                                        </div>
                                        </ul>
                                    </ul>
                                 </th>
                                <th colspan="2"  class="pl-2 ">
                                     <ul style="list-style:none" class="mb-5 pb-5">
                                        <li>Client: {{item.toDepartmentName}}</li>
                                        <li>Reg. com.: J22/836/2002 </li>
                                        <li>CIF: RO14816433</li>
                                        <li>Adresa: {{item.toAddress}} </li>
                                        <li>Judet: Iasi</li>
                                    </ul>
                                </th>
                            </tr>

						<tr style="font-weight:bold">
							<th class="p-1">Nr. crt</th>
							<th class="p-1">Denumirea produselor sau a serviciilor</th>
							<th class="p-1">U.M.</th>
							<th class="p-1">Cant.</th>
							<th class="p-1"  style="width:15px">Pret unitar (fara TVA) -Lei</th>
							<th class="p-1">Valoarea -Lei</th>
							<th class="p-1">Valoarea TVA -Lei</th>
						</tr>

						<tbody>

						<tr v-for="whItem,index in item.whItems" :key="whItem.id +'field'" v-if="whItem.count > 0">
                            <td style="width:10px">{{index+1}}</td>
                            <td>{{whItem.itemName}}</td>
                            <td>{{whItem.unitName}}</td>
                            <td>{{whItem.count}}</td>
                            <td>{{ calculatePriceWithoutNds(whItem) | currency({ fractionCount: 2,fractionSeparator:','})}}</td>
                            <td>{{calculatePriceWithoutNds(whItem) * whItem.count | currency({ fractionCount: 2,fractionSeparator:','}) }}</td>
                            <td >{{(whItem.priceUzs - calculatePriceWithoutNds(whItem)) * whItem.count |  currency({ fractionCount: 2,fractionSeparator:','}) }}</td>
                         </tr>
						</tbody>

                            <tr>
                                <td rowspan="4">Semnatura si stampila furnizorului</td>
                                <td colspan="3" rowspan="4">
									<ul style="list-style:none">
										<li>Intocmit de: 		</li>
										<li>CNP: </li>
										<li> Numele delegatului: </li>
										<li> B.I/C.I:</li>
										<li>Mijloc transport: </li>
										<li>Expedierea s-a efectuat in prezenta noastra la data de.................... ora......... </li>
										<li>Semnaturile:</li>
									</ul>
								</td>
                                <td>Total</td>
                                <td>{{ calculateAllTotalPrice | currency({ fractionCount: 2,fractionSeparator:','}) }}</td>
                                <td>{{calculateAllTotalNds | currency({ fractionCount: 2,fractionSeparator:','}) }}</td>
                            </tr>
                            <tr>
                                <td>Total plata</td>
                                <td colspan="2">{{calculateAllTotalNds + calculateAllTotalPrice | currency({ fractionCount: 2,fractionSeparator:','}) }}</td>
                            </tr>
                              <tr>
                                <td colspan="3">Data primirii in gestiune si semnatura</td>
                            </tr>
                              <tr>
                                <td colspan="3">Semnatura de primire:</td>
                            </tr>

					</table>
					</div>
					<div v-if="loader" class="spinner-wrapper">
						<b-spinner variant="primary"></b-spinner>
					</div>
				</div>
			</b-card>
			<b-modal
			hide-footer
			v-model="modalAviz">
			<b-row>
			<b-col cols="4" class="pt-1" >
				Descriere
			</b-col>
			<b-col cols="8">
				<multiselect
				class="pt-1"
				:placeholder="$t('users-l.create.employee')"
				v-model="value"
				:custom-label="userSelectedOption"
				:options="options">
				</multiselect>
			</b-col>
			<br>
			<br>
			<b-col cols="4" class="pt-1" >
				Tip document
			</b-col>
			<b-col cols="8">
				<b-input :disabled="true" value="Aviz"></b-input>
			</b-col>
			<br>
			<br>
			<b-col cols="4" class="pt-1" >
				Denimure serie
			</b-col>
			<b-col cols="8">
				<b-input v-model="name"></b-input>
			</b-col>
			<br>
			<br>
			<b-col cols="4" class="pt-1" >
				Primal numar
			</b-col>
			<b-col cols="8">
				<b-input v-model="regNumberAviz"></b-input>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col cols="6"></b-col>
			<b-col cols="3" class="text-right">

				<!-- <b-button variant="danger" @click="closeAvizModal">
					{{$t('cancel')}}
				</b-button> -->
			</b-col>
			<b-col cols="3" class="text-right">
				<b-button @click="editAvizDocForUser" variant="success">
					{{$t('save')}}
				</b-button>
			</b-col>
		</b-row>
		</b-modal>
		</div>
	</b-container>
</template>

<script>
import {mapActions} from 'vuex';
import WhDocument from "../../../../services/wh-document.service";
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import EmployeeSerive from "../../../../services/employees.service"
import CreateForm from "../blocks/CreateForm";

export default {
		name: 'Show',

		data() {
			return {
				regNumber:null,
				vatPercentage: null,
				name: null,
				aviz:null,
				regNumberAviz: null,
				docId: null,
				value: null,
        		options: [],
				modalAviz: false,
				loader: false,
				item: {},
				totalPrice: {
					uzs: 0,
					usd: 0,
					saleTypePrice: 0,
				},
				priceType: 'uzs',
				income: [],
				totalIncome: {
					uzs: 0,
					usd: 0
				},
				confirmBarcodeGenerate: false,
				barcodeCount: 0,
				currentWhItems: [],
				sidebar: {
					open: false,
					close: false
				},
				backTo: null,
			}
		},

		methods: {
			getDepartmentInfo() {
				if (this.$can('get', 'warehouse-document')) {
				this.loader = true;
				return WhDocument.getDeparmentForDocument(this.item.fromDepartmentId).then(res => {
					this.loader = false;
					this.vatPercentage = res.data.vatPercentage
					this.item.fromAddress = res.data.address
					this.item.fromBankAccount = res.data.bankAccount
					this.item.toAddress = res.data.address
					this.item.toBankAccount = res.data.bankAccount
					// this.item = response.data;
					// this.sumPrice(this.item);
					// this.sumIncome(this.item);
				}).catch(error => {
					this.loader = false
				})
				}
			},
			async editAvizDocForUser() {
				try{
					let payload = {
						whDocumentId: this.item.id,
						responsibleId: this.value.id,
						regNumber: this.regNumberAviz,
						initialLetter: this.name
					}
					if(this.value) {
						let res = await EmployeeSerive.editAviz(this.aviz.id, payload)
						if(res.data) {
						await this.get()
						await this.getDepartmentInfo()
						await this.getAviz()
						this.modalAviz = false;
					}
					}
				}catch (e) {
					if(e.request.response) {
						let res = JSON.parse(e.request.response)
						this.$vs.notify({
							title: this.$t('words.error'),
							text: res.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					}
				}
			},
			userSelectedOption (user) {
				return user.firstName + ' ' + user.lastName ;
			},
			async editAvizModal() {
				// this.regNumberAviz = null;
				// this.value = null
				this.modalAviz = true
			},
			...mapActions('warehouse', [
				'setFromIncomeToTransfer', 'setCurrentWhItems'
            ]),
            calculateRealCostOfItem(item) {
				/*let sumOfPriceWithoutNds = (item.priceWholesale/1.2) * item.count;
                let sumOfNds = ((item.priceWholesale * item.count) * 0.2)/1.2;*/
				if (item.priceUzs > 0) {
					return item.priceUzs* item.count;
				} else {
					return 0
				}
			},
			calculateNdsOfItem(item) {
				return this.calculateRealCostOfItem(item) / 6;
			},
			calculateSumOfItemWithoutNds(item) {
				return this.calculateRealCostOfItem(item) - this.calculateNdsOfItem(item);
			},
			calculatePriceWithoutNds(item) {
				return this.calculateSumOfItemWithoutNds(item) / item.count;
			},
			calculateTotalRealCost() {
				let temp = 0;
				if(this.item.whItems) {
                for (let i = 0; i < this.item.whItems.length; i++) {
                            temp += this.calculateRealCostOfItem(this.item.whItems[i]);
                        }
                  }
				return temp;
			},
			updateWeight(item) {
				if (item.sumWeightAllItems > 1000) {
					return item.sumWeightAllItems / 1000 + ' кг';
				}
				if (item.sumWeightAllItems < 1000) {
					return item.sumWeightAllItems + ' гр';
				}
				if (item.sumWeightAllItems > 1000000) {
					return item.sumWeightAllItems / 1000000 + ' тонна';
				}
			},
			async getAviz() {
				if (this.$can('get', 'warehouse-document')) {
					this.loader = true;
					let res = await EmployeeSerive.getEmployeeIfHaveLogin(this.item.toDepartmentId)
					this.options = res.data
					return EmployeeSerive.hasAvizDocument(this.$route.params.id).then(response => {
						this.aviz = response.data;
						this.name  = response.data.initialLetter
						this.regNumber = response.data.regNumber
						if(response.data.regNumber <= 9) {
						this.regNumber = '000'+response.data.regNumber
						}else if(response.data.regNumber <= 99 && response.data.regNumber > 9){
							this.regNumber= '00'+response.data.regNumber
						}else {
							this.regNumber = '0'+response.data.regNumber
						}
						this.options.forEach(el => {
							if(el.id == response.data.responsibleId) {
								this.value = el
							}
						})
						this.loader = false;
					}).catch(error => {
						this.loader = false
					})
				}
			},
			get() {
				if (this.$can('get', 'warehouse-document')) {
					this.loader = true;
					return WhDocument.get(this.$route.params.id).then(response => {
						this.loader = false;
						this.item = response.data;
						this.sumPrice(this.item);
						this.sumIncome(this.item);
					}).catch(error => {
						this.loader = false
					})
				}
			},
			sumPrice(item) {
				if (typeof item.whItems === 'object') {
					Object.values(item.whItems).map(item => {
						if (item.priceUsd) this.totalPrice.usd += item.priceUsd * item.count;
						if (item.priceUzs) this.totalPrice.uzs += item.priceUzs ? item.priceUzs * item.count : 0;
						if (item.saleTypePrice) this.totalPrice.saleTypePrice += item.saleTypePrice ? item.saleTypePrice * item.count : 0;
					});
				}
			},
			sumIncome(item) {
				if (typeof item.whItems === 'object') {
					Object.values(item.whItems).map(item => {
						this.totalIncome.usd += item.incomingPriceUsd * item.count;
						this.totalIncome.uzs += item.incomingPriceUzs ? item.incomingPriceUzs * item.count : 0;
					});
				}
			},
			formatDate(date, format = 'DD-MM-YYYY') {
				if (date) {
					const split = date.split(' ');
					date = split[0];
					const revers = date.split('-');
					date = revers[2] + '-' + revers[1] + '-' + revers[0] + 'T00:00:00';
					return moment(String(date)).format(format)
				}
			},
			goBackToFrom() {
				this.$router.back();
			},
			print() {
				window.print();
			},
			openSidebar() {
				setTimeout(() => {
					this.sidebar.open = true
				}, 200)
			},

			generateBarcode() {
				//this.currentWhItems = Object.assign({}, this.item.whItems);
				this.currentWhItems = JSON.parse(JSON.stringify(this.item.whItems));
				this.confirmBarcodeGenerate = true;
				//this.$router.push(`/warehouse-management/income/barcodes/${this.$route.params.id}`);

			},
			cancelBarcodeGenerate() {
				this.confirmBarcodeGenerate = false;
			},
			submitBarcodeGenerate() {
				let items = {};
				items.status = true;
				items.data = this.currentWhItems.filter(column => column.checked === true);
				items.data.forEach((item, index) => {
					items.data[index].count = parseInt(item.count)
				});
				this.setCurrentWhItems(items);
				this.$router.push(`/warehouse-management/income/barcodes`);
			},

			remove() {
				WhDocument.remove(this.item.id).then(response => {
					this.$router.push('/warehouse-management/income');
				})
			},

			showConfirm(item) {
				let refName = 'popover' + item;
				this.$refs[refName].$emit('open')
			},
			closeConfirm(item) {
				let refName = 'popover' + item;
				this.$refs[refName].$emit('close')
			},
			excelExport(table, fileName = '') {


				var uri = 'data:application/vnd.ms-excel;base64,'
					,
					template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
					, base64 = function (s) {
						return window.btoa(unescape(encodeURIComponent(s)))
					}
					, format = function (s, c) {
						return s.replace(/{(\w+)}/g, function (m, p) {
							return c[p];
						})
					}
					, downloadURI = function (uri, name) {
						var link = document.createElement("a");
						link.download = name;
						link.href = uri;
						link.click();
					}

				if (!table.nodeType) table = document.getElementById(table)
				var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
				var resuri = uri + base64(format(template, ctx))
				downloadURI(resuri, fileName);
			},


		},
		async created() {
			await this.get();
			await this.getDepartmentInfo()
			await this.getAviz();
		},
		computed: {
			calculateAllTotalPrice(){
				let temp = 0
				this.item.whItems.forEach(el=> {
					temp += this.calculatePriceWithoutNds(el) * el.count
				})
				return temp
			},
			calculateAllTotalNds() {
				let temp = 0
				this.item.whItems.forEach(el=> {
					temp += (el.priceUzs - this.calculatePriceWithoutNds(el)) * el.count
				})
				return temp
			},
			/*incomeField() {
				return this.income[0]
			},*/
			totalCount() {
				let sum = 0;
				if (this.item.whItems) {
					if (this.item.whItems.length > 0) {
						this.item.whItems.forEach(el => {
							sum += el.count;
						});
					}
				}
				return sum;
			}
		},
		components: {
			CreateForm,
			Multiselect
		},
		watch: {
			value: {
				async handler(newVal) {
					if(newVal) {
						if(newVal.id == this.aviz.responsibleId) {
							this.regNumberAviz = this.regNumber
						}else {
							let res = await EmployeeSerive.getRegNumber(newVal.id)
							if(res.data <= 9) {
								this.regNumberAviz = '000'+res.data
							}else if(res.data <= 99 && res.data > 9){
								this.regNumberAviz = '00'+res.data
							}else {
								this.regNumberAviz = '0'+res.data
							}
							this.name = newVal.firstName.charAt(0)
							}
					}
				}
			}
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
     table.table-bordered >tr > th{
        border:1.5px solid black;
    }
    table.table-bordered > .thead-first > th{
        border-top:0px solid white;
        border-right: 0px solid white;
        border-left:0px solid white;
        border-bottom: 0px solid black
    }
    table.table-bordered > tbody > tr > td{
        border:1.5px solid black;
    }
    table.table-bordered  > tr > td{
        border:1.5px solid black;
    }

    table.table-bordered > .thead-first >  th:nth-child(1) {
        width: 33.3%;
    }
     table.table-bordered > .thead-first > th:nth-child(2) {
        width: 33.3%;
    }
     table.table-bordered > .thead-first > th:nth-child(3) {
        width: 33.3%;
    }

    p {
        margin: 0
    }

	@media print {
    	.hidden-print {
			display: none;
		}
        table.table-bordered > .thead-first > tr > th{
            border:0px solid white !important;
        }
		.card {
			box-shadow: none;
		}
	}

	.generalTableClass {
		.table {
			td, th {
				font-size: 12px;
			}
		}
	}

	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}
</style>
